/**
 * These identifiers are used by our e2e tests.
 */
const E2E_TEST_SELECTORS = {
  SUBMISSION_UPLOAD_ARTICLE_TYPE: 'articleTypeSelection'
};

export default E2E_TEST_SELECTORS;
